export default "/images/framework/BgPink.60f61972.svg?60f61972";